import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicApplicationsStatisticsReport',
  // mixins: [listMixin],
  props: {
    statisticsObj: {
      type: Object,
      required: true
    },
    customPeriod: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      spreadingFactorAverage: 0,
      snrFullData: [],
      panelHeaders: [this.$i18n_t('NiotaClassic.Applications.details.dailyReport'), this.$i18n_t('NiotaClassic.Applications.details.monthlyReport')],
      statistics: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  },
  created() {
    this.application = cloneDeep(this.applicationObj);
  },
  methods: {}
};